<template>
  <ts-card>
    <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
      <h4 class="ts-text-sm">{{ $t('payItemOvertime.pageTitle') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('payItemOvertime.otName') }}</label>
              <div>
                <ts-input v-model="model.ot_name" :class="{ 'is-invalid': errors.has('ot_name') }" autofocus />
                <div class="invalid-feedback" v-if="errors.has('ot_name')">{{ errors.first('ot_name') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('payItemOvertime.otCategory') }}</label>
              <div>
                <ts-select
                  v-model="model.ot_category"
                  :options="['Weekday', 'Weekend', 'Day Off', 'Holiday', 'Night Shift']"
                />
                <div class="invalid-feedback" v-if="errors.has('ot_category')">{{ errors.first('ot_category') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('payItemOvertime.otRate') }}</label>
              <div>
                <ts-input
                  type="number"
                  v-model.number="model.ot_rate"
                  :class="{ 'is-invalid': errors.has('ot_rate') }"
                />
                <div class="invalid-feedback" v-if="errors.has('ot_rate')">{{ errors.first('ot_rate') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label">{{ $t('payItemOvertime.description') }}</label>
              <div>
                <ts-textarea v-model="model.description" rows="3" />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <div>
                <ts-checkbox v-model="model.is_taxable">{{ $t('payItemOvertime.isTaxable') }}</ts-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button @click.prevent="$emit('close')" :disabled="saving">{{ $t('button.cancel') }}</ts-button>
            <ts-button
              outline
              color="primary"
              class="ml-2"
              :waiting="savingAndNew"
              @click.prevent="saveAndNew"
              v-if="editData === undefined"
              >{{ $t('button.createAndNew') }}</ts-button
            >
            <ts-button color="primary" class="ml-2" :waiting="saving" @click.prevent="save">
              {{ editData ? $t('button.update') : $t('button.create') }}
            </ts-button>
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { cloneDeep } from 'lodash'

export default {
  name: 'pay-item-overtime-form',
  props: ['editData'],
  data() {
    const model = {
      ot_name: this.editData ? this.editData.ot_name : '',
      is_taxable: this.editData ? this.editData.is_taxable : false,
      ot_category: this.editData ? this.editData.ot_category : '',
      ot_rate: this.editData ? this.editData.ot_rate : '',
      description: this.editData ? this.editData.description : ''
    }

    return {
      newModel: model,
      model: cloneDeep(model),
      errors: new Errors(),
      saving: false,
      savingAndNew: false
    }
  },
  methods: {
    submit() {
      let responseResult

      this.errors = new Errors()

      if (this.editData) {
        responseResult = this.$store.dispatch('hr/payItemOvertime/update', {
          id: this.editData.ot_id,
          ...this.model
        })
      } else {
        responseResult = this.$store.dispatch('hr/payItemOvertime/create', this.model)
      }

      return responseResult
        .then(response => {
          return this.$store.dispatch('hr/payItemOvertime/fetch').then(res => {
            this.saving = false
            this.$toasted.success(response.message)
            return Promise.resolve(res)
          })
        })
        .catch(error => {
          if (error.errors) this.errors = new Errors(error.errors)
          else this.$toasted.error(error.message)

          return Promise.reject(error)
        })
    },
    save() {
      this.saving = true

      this.submit()
        .then(() => {
          this.$emit('close')
        })
        .finally(() => {
          this.saving = false
        })
    },
    saveAndNew() {
      this.savingAndNew = true

      this.submit()
        .then(() => {
          this.model = cloneDeep(this.newModel)
        })
        .finally(() => {
          this.savingAndNew = false
        })
    }
  }
}
</script>
